import React, {useEffect, useState} from 'react'
import moment from "moment";
import {message, Pagination, Spin} from "antd"
import parseToken from "../../../helpers/parseToken";
import {formatDate3} from "../../../helpers/formatDate";
import {getUserDataLevel} from "../../../services/api/apiLead";
import ReportCallFeeSearch from "./search/ReportCallFeeSearch";
import {reportCallFee} from "../../../services/api/apiReport2";
import Export from "./actions/Export";
import {searchTenant} from "../../../services/api/apiUser";
import {getListShortPhoneByTenant} from "../../../services/api/apiCustomerHub";

const ReportCallFeePage = (props) => {
    const {custId, custName} = props
    const [level, setLevel] = useState(0)
    const [showFilter, setShowFilter] = useState(false)
    const [filters, setFilters] = useState({
        fromDate: moment().subtract(0, 'days').startOf('day'),
        toDate: moment().endOf('day'),
        tenantId: custId,
        tenantName: custName,
        shortPhone: "",
        page: 1,
        limit: 20
    })
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [tenants, setTenants] = useState([])
    const [shortPhone, setShortPhone] = useState([])
    const [total, setTotal] = useState(0)
    const info = parseToken()

    const _onToggleFilter = () => {
        setShowFilter(!showFilter)
    }

    const _onChangeFilters = async (name, value) => {
        if (name === 'tenantId') {
            _fetchListShortPhone(value)
        }
        await setFilters({
            ...filters,
            [name]: value,
            page: 1
        })
    }

    const _onChangeDateFrom = (value) => {
        setFilters({
            ...filters,
            fromDate: value,
            page: 1
        })
    }

    const _onChangeDateTo = (value) => {
        setFilters({
            ...filters,
            toDate: value,
            page: 1
        })
    }

    const _fetchListReport = async () => {
        if (level === 0) return
        setLoading(true)
        setError('')

        try {
            const decodeToken = parseToken()
            const _tenant = tenants.find(item => item.value === parseInt(filters.tenantId))
            const payload = {
                ...filters,
                tenantName: _tenant !== undefined ? _tenant.name : '',
                level: level,
                fromDate: formatDate3(filters.fromDate) + ' 00:00:00',
                toDate: formatDate3(filters.toDate) + ' 23:59:00',
                userName: decodeToken.sub,
                pagesize: filters.limit + '',
                page: filters.page + ''
            }
            console.log(tenants)
            const response = await reportCallFee(payload);
            const {headers, data} = response
            const contentResponse = JSON.parse(headers["content-response"])
            setTotal(contentResponse.data)
            document.getElementById('ReportByConvertedLeadElm').innerHTML = data.replaceAll('file:/u02/ipcc/report/services-report/./../../omap/IPCCMedia/webapps/IPCCMedia/images', import.meta.env.REACT_APP_LINK_SVG_CHART || 'https://103.116.106.115:1770/IPCCMedia/images')

            setLoading(false)
        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    const _fetchListTenant = async () => {
        try {
            const payload = {
                page: 1,
                limit: 10000
            }
            const response = await searchTenant(payload, info.sub)
            const {success, data, message: error} = response
            console.log(<data></data>)

            if (success !== '1') {
                return message.error(error)
            }

            const _tenants = data.map(item => {
                return {
                    label: item.name,
                    name: item.name,
                    value: item.id,
                }
            })

            setTenants([..._tenants])
            if (_tenants.length === 1) {
                setFilters({
                    ...filters,
                    tenantId: _tenants[0].value + ''
                })
                _fetchListShortPhone(_tenants[0].value)
            }
        } catch (e) {
            message.error(e.message)
        }
    }

    const _fetchListShortPhone = async (tenantId) => {
        try {
            const payload = {
                tenantId: parseInt(tenantId)
            }
            const response = await getListShortPhoneByTenant(info.sub, payload)
            const {success, data, message: error} = response

            if (success !== '1') {
                return message.error(error)
            }

            const _shortPhone = data.map(item => {
                return {
                    label: item.shortPhone,
                    name: item.shortPhone,
                    value: item.shortPhone,
                }
            })

            setShortPhone([..._shortPhone])
        } catch (e) {
            message.error(e.message)
        }
    }

    const _getUserDataLevel = async () => {
        try {
            const payload = {
                userName: info.sub,
                dataObject: "REPORT",
                dataAction: "VIEW"
            }
            const {data} = await getUserDataLevel(payload)
            const {success, datalevel} = data
            if (parseInt(success) !== 1) {
                return
            }
            await setLevel(datalevel)
            //await _fetchListReport(datalevel)
        } catch (e) {

        }
    }

    const _onChangePagination = (page, pageSize) => {
        setFilters({
            ...filters,
            limit: pageSize,
            page: pageSize !== filters.limit ? 1 : page
        })
        _fetchListReport()
    }

    useEffect(() => {
        _getUserDataLevel()
        _fetchListTenant()
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        _fetchListReport()
        // eslint-disable-next-line
    }, [level])

    return (
        <div className="ReportByDayPage PageDefault">

            <div className="PageHeading">
                <h1 className="PageTitle">Báo cáo chi tiết cước</h1>
                <div className="PageFilterTop">
                    <div className="FiltersOpen" onClick={_onToggleFilter}>
                        <span className="material-icons Filter">filter_list</span>
                        <label>Bộ lọc</label>
                    </div>
                    <div><Export filters={filters} tenants={tenants} level={level}/></div>
                </div>
            </div>
            {
                showFilter && <div className="Filter">
                    <ReportCallFeeSearch
                        tenants={tenants}
                        shortPhone={shortPhone}
                        filters={filters}
                        onChangeFilters={_onChangeFilters}
                        receptionDateFrom={filters.fromDate}
                        receptionDateTo={filters.toDate}
                        onChangeTo={_onChangeDateTo}
                        onChangeFrom={_onChangeDateFrom}
                        fetchListReport={_fetchListReport}
                    />
                </div>
            }
            <Spin spinning={loading} tip="Đang lấy dữ liệu từ server...">
                <div id="ReportByConvertedLeadElm" className="tableReportNormal reportCallFee"></div>
                <div className="PagePagination d-flex justify-content-end align-items-center mt-3">
                    <div className="total mr-3">Total {total} items</div>
                    <Pagination
                        className="PaginationCustom"
                        pageSizeOptions={['20', '50', '100', '200']}
                        total={total}
                        showSizeChanger={true}
                        pageSize={parseInt(filters.limit)}
                        current={parseInt(filters.page)}
                        onChange={_onChangePagination}
                    />
                </div>

                {error && <div className="text-danger mt-3">{error}</div>}
            </Spin>
        </div>
    )
}

export default ReportCallFeePage
